import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-number-input-modal',
  templateUrl: './number-input-modal.component.html',
  styleUrls: ['./number-input-modal.component.css']
})
export class NumberInputModalComponent {
  @Input() headerText: string = 'Number Input';
  @Input() bodyText: string = '';
  @Input() inputLabelText: string = 'Input number: ';
  @Input() saveButtonText: string = 'Save';
  @Input() cancelButtonText: string = 'Cancel';
  inputValue: number | null = null;

  constructor(private activeModal: NgbActiveModal) { }

  saveAndClose () {
    this.activeModal.close(this.inputValue);
  }

  close () {
    this.activeModal.close(this.inputValue);
  }

}